<kendo-grid [data]="notesView.gridData" [loading]="notesView.loading"
    [pageable]="notesCount > notesView.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
    [pageSize]="notesView.state.take" [skip]="notesView.state.skip" [sortable]="true" [sort]="notesView.state.sort"
    [filterable]="enableAdvanced" [filter]="notesView.state.filter" [groupable]="enableAdvanced"
    [group]="notesView.groups" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
    [reorderable]="enableAdvanced" (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)">
    <kendo-grid-messages noRecords="{{ 'NO-NOTES' | translate }}">
    </kendo-grid-messages>
    <kendo-grid-column field="type" [width]="10" title="{{ 'TYPE' | translate }}"></kendo-grid-column>
    <kendo-grid-column field="title" [width]="40" title="{{ 'TITLE' | translate }}" class="ellipsis-text">
    </kendo-grid-column>
    <kendo-grid-column field="body" [width]="70" title="{{ 'NOTES' | translate }}" class="ellipsis-text">
        <ng-template kendoGridCellTemplate let-dataItem>
            <a *ngIf="!dataItem.taskId" class="pointer" (click)="editHandler(dataItem)">
                <span class="ellipsis-text">{{ dataItem.body | replaceLineBreaks }}</span>
            </a>
            <a *ngIf="dataItem.taskId" class="pointer" (click)="editHandler(dataItem)">
                <span [innerHTML]="getTaskNoteBody(dataItem.body) | replaceLineBreaks"></span>
            </a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="createdOn" [width]="25" title="{{ 'CREATED-DATE' | translate }}" filter="date"
        format="{0:g}">
    </kendo-grid-column>
    <kendo-grid-column field="lastModifiedOn" [width]="25" title="{{ 'LAST-MODIFIED-DATE' | translate }}" filter="date"
        format="{0:g}">
    </kendo-grid-column>
    <kendo-grid-column field="authorName" [width]="20" title="{{ 'DOCUMENT-AUTHOR-PERSON' | translate }}"
        class="ellipsis-text">
    </kendo-grid-column>
</kendo-grid>
<div class="pr-1">
    <button kendoButton [primary]="true" (click)="createNote()" type="button" class="mt-3 mb-3 float-right">
        {{'ADD' | translate}}<i class="far fa-plus"></i>
    </button>
</div>
<!--Note Add/Edit modal-->
<app-notes [isNew]="isNew" [notesDialogOpened]="notesDialogOpened" [note]=currentNote (removed)="onNoteRemoved()"
    (added)="onNoteAdded()" (cancelling)="onNoteCancel()">
</app-notes>